const Reporte = () => {
  return (
    <div
      className="container-md bg-light px-3 py-5"
      style={{ maxWidth: "1000px", borderRadius: "10px" }}
    >
      <div className="row">
        <h1>EN MANTENIMIENTO</h1>
      </div>
    </div>
  );
};

export default Reporte
